(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-onclick-info"]) return;
  try {
    
 document.addEventListener('DOMContentLoaded', function() {
  var buttons = document.querySelectorAll('.toggle-button');
  var contents = document.querySelectorAll('.toggle-content');
  var currentlyOpenContent = null;

  // Initially hide contents by changing their visibility, not display
  contents.forEach((content) => {
    content.style.visibility = 'hidden';
  });

  buttons.forEach((button, index) => {
    button.addEventListener('click', function() {
      var content;
      if (this.parentElement.classList.contains('button-container-right')) {
        // If the button is in the right container, its content is the next sibling
        content = this.nextElementSibling.querySelector('.toggle-content');
      } else {
        // If the button is in the left container, its content is the previous sibling
        content = this.previousElementSibling.querySelector('.toggle-content');
      }

      // if there is a panel open and it's the same as the one clicked on
      if (currentlyOpenContent && content === currentlyOpenContent) {
        content.style.visibility = 'hidden';
        currentlyOpenContent = null;
      } else {
        // hide all contents
        contents.forEach((content) => {
          content.style.visibility = 'hidden';
        });

        // show the clicked content
        content.style.visibility = 'visible';
        currentlyOpenContent = content;
      }
    });
  });
});




  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-product-breakdown"]) return;
  try {
    

let addToCartButton = document.querySelector('.breakdown-add');

addToCartButton.addEventListener('click', function() {
  let selectedRadio = document.querySelector('input[name="option"]:checked');
  let variantId = selectedRadio.dataset.variantId;
  addVariantToCart(variantId);
});

function addVariantToCart(variantId) {
  fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest'
    },
    body: JSON.stringify({
      quantity: 1,
      id: variantId
    })
  })
  .then(response => {
    if (response.ok) {
      return response.json();
    } else {
      throw new Error('Something went wrong');
    }
  })
  .then(data => {
    console.log('Item added to cart', data);
    // save current scroll position to local storage
    localStorage.setItem('scrollPosition', JSON.stringify({
      x: window.scrollX,
      y: window.scrollY
    }));
    // refresh page
    location.reload();
  })
  .catch(error => {
    console.error('Error:', error);
  });
}

// on page load, check local storage for saved scroll position
window.onload = function() {
  let scrollPosition = JSON.parse(localStorage.getItem('scrollPosition'));
  if (scrollPosition) {
    window.scrollTo(scrollPosition.x, scrollPosition.y);
    // remove saved scroll position from local storage
    localStorage.removeItem('scrollPosition');
  }
}

  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-subscription-info"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', (event) => {
    function openTab(tabName, elmnt) {
      var i, tabcontent, tablinks;
  
      tabcontent = document.getElementsByClassName("sub-info-tabcontent");
      for (i = 0; i < tabcontent.length; i++) {
        tabcontent[i].style.display = "none";
      }
  
      tablinks = document.getElementsByClassName("sub-info-star");
      for (i = 0; i < tablinks.length; i++) {
        tablinks[i].className = tablinks[i].className.replace(" star-active", "");
      }
  
      document.getElementById(tabName).style.display = "block";
      elmnt.parentNode.className += " star-active";
    }
  
    // Assigning event listeners to the tabs
    var tabs = document.querySelectorAll('.sub-info-tablink');
    tabs.forEach(tab => {
      var tabId = 'sub-info-' + tab.textContent.trim(); // Get the text of the tab
      tab.addEventListener('click', function(){openTab(tabId, this);});
    });
  
    // Get the element with id="sub-info-defaultOpen" and click on it
    document.getElementById("sub-info-defaultOpen").click();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-settle-bulk"]) return;
  try {
    
  // You can add JavaScript here if needed

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-two-column"]) return;
  try {
    
  // You can add JavaScript here if needed

  } catch(e) { console.error(e); }
})();
})();
